import { useState } from 'react';
import storageKey from 'helpers/storageKey';

const useLocalStorage = (key, initialValue) => {
  // Qualified by context path so instances sharing an origin keep separate values.
  const scopedKey = storageKey(key);
  const [storedValue, setStoredValue] = useState(() => {
    const item = window.localStorage.getItem(scopedKey);
    return item ? JSON.parse(item) : initialValue;
  });

  const setValue = (value) => {
    const valueToStore =
      value instanceof Function ? value(storedValue) : value;
    setStoredValue(valueToStore);
    window.localStorage.setItem(scopedKey, JSON.stringify(valueToStore));
  };

  return [storedValue, setValue];
};

export default useLocalStorage;
